import { render, staticRenderFns } from "./hrd-add-program-event.vue?vue&type=template&id=2bddda50&scoped=true"
import script from "./hrd-add-program-event.vue?vue&type=script&lang=js"
export * from "./hrd-add-program-event.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-program-event.vue?vue&type=style&index=0&id=2bddda50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bddda50",
  null
  
)

export default component.exports